import React from 'react';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';
const negations = ['No estás rota.', 'No estás perdida.', 'No te falta fuerza.'];
export function ProblemSection() {
  return <section className="w-full bg-shell py-20 md:py-28" aria-labelledby="verdad" data-id="element-180" data-mp="30hhgbq9fuq6l">
      <div className="mx-auto max-w-4xl px-6 lg:px-8" data-id="element-181" data-mp="2vpzcmug16bhx">
        <SectionHeading eyebrow="La verdad" title={<span id="verdad" data-id="element-183" data-mp="39hcs9xatip7o">La verdad que nadie te dijo…</span>} data-id="element-182" data-mp="2voegj0e2ikhy" />

        <div className="mt-12 grid gap-4 sm:grid-cols-3" data-id="element-184" data-mp="39jqmk3xobxe6">
          {negations.map((line, i) => <Reveal key={line} delay={i * 0.1} data-id="element-185" data-mp="35g0x7c96dbs3" data-mpi={i}>
              <p className="rounded-2xl bg-ivory px-6 py-7 text-center font-display text-2xl font-light text-ink" data-id="element-186" data-mp="3jglgsamwzbmn">
                {line}
              </p>
            </Reveal>)}
        </div>

        <div className="mx-auto mt-12 max-w-reading space-y-5 text-center font-sans text-[1rem] font-light leading-[1.9] text-warmgray" data-id="element-187" data-mp="1p1ssyxs9vp59">
          <Reveal delay={0.05} data-id="element-188" data-mp="1k4999ict2k5x">
            <p className="font-display text-2xl italic text-ink" data-id="element-189" data-mp="1k5anfvp4bmrv">
              Simplemente llevas demasiado tiempo desconectada de ti.
            </p>
          </Reveal>
          <Reveal delay={0.1} data-id="element-190" data-mp="ocpz8t045jy4">
            <p data-id="element-191" data-mp="o9tzr08man7k">Muchas mujeres aprenden a cuidar todo excepto a ellas mismas.</p>
          </Reveal>
          <Reveal delay={0.15} data-id="element-192" data-mp="sbyrftfi99rk">
            <p data-id="element-193" data-mp="x51m64w0qp9c">
              Y cuando dejan de escucharse durante demasiado tiempo, empiezan a olvidar quiénes
              son.
            </p>
          </Reveal>
        </div>
      </div>
    </section>;
}